import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Box, Field, Input } from '@chakra-ui/react';
import { Checkbox } from '@/components/ui/checkbox';
import { InformationIcon } from '@/components/util-component/InformationIcon';
type WarningOptionWithThresholdProps = {
  label: string;
  checked: boolean;
  threshold: string;
  info?: string;
  invalid?: boolean;
  onCheckedChange: (checked: boolean) => void;
  onThresholdChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  ariaLabel?: string;
};
export const WarningOptionWithThreshold = t0 => {
  const $ = _c(26);
  const {
    label,
    checked,
    threshold,
    info,
    invalid: t1,
    onCheckedChange,
    onThresholdChange,
    ariaLabel
  } = t0;
  const invalid = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== onCheckedChange) {
    t2 = e => onCheckedChange(!!e.checked);
    $[0] = onCheckedChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <Box whiteSpace="nowrap">{label}</Box>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== checked || $[5] !== t2 || $[6] !== t3) {
    t4 = <Checkbox checked={checked} onCheckedChange={t2}>{t3}</Checkbox>;
    $[4] = checked;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Field.Label fontSize="xs">(Threshold (%):</Field.Label>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      borderColor: "red.500"
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = ariaLabel || `${label} threshold`;
  let t8;
  if ($[10] !== onThresholdChange || $[11] !== t7 || $[12] !== threshold) {
    t8 = <Input _invalid={t6} aria-label={t7} ml={1} size="2xs" step="0.1" type="number" value={threshold} width="60px" onChange={onThresholdChange} />;
    $[10] = onThresholdChange;
    $[11] = t7;
    $[12] = threshold;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Field.Label fontSize="xs">)</Field.Label>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== invalid || $[16] !== t8) {
    t10 = <Field.Root alignItems="center" display="flex" flexDirection="row" gap={1} invalid={invalid}>{t5}{t8}{t9}</Field.Root>;
    $[15] = invalid;
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t4) {
    t11 = <Box alignItems="center" display="flex" flex="1" gap={2}>{t4}{t10}</Box>;
    $[18] = t10;
    $[19] = t4;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== info) {
    t12 = info && <Box style={{
      width: "20px",
      height: "20px",
      position: "absolute",
      right: "-6px",
      top: "-8px"
    }}><InformationIcon contentWidth="380px" info={info} whiteSpace="pre-line" /></Box>;
    $[21] = info;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = <Box alignItems="center" display="flex" position="relative" width="100%">{t11}{t12}</Box>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};